import logo from './logo.svg';
import './App.css';
import About from "./components/About/About";
import NavBar from "./components/NavBar/NavBar";
import Projects from "./components/Projects/Projects";
import Publications from "./components/Publications/Publications";
import Teaching from "./components/Teaching/Teaching";
import Contact from "./components/Contact/Contact";
import { useEffect, useState } from 'react';

function App() {
  const [activeSection, setActiveSection] = useState(-1);

  useEffect(() => {
    const header = document.querySelector("header");
    const sections = document.querySelectorAll("section");
    
    const offsets = [];
    sections.forEach(section => {
        offsets.push(section.offsetTop);
    });

    window.onscroll = (e) => {
      const scrollTop = document.documentElement.scrollTop;
      
      if (scrollTop < offsets[1] - header.offsetHeight) {
        setActiveSection(-1);
      } else if (scrollTop < offsets[2] - header.offsetHeight) {
        setActiveSection(0);
      } else if (scrollTop < offsets[3] - header.offsetHeight) {
        setActiveSection(1);
      } else if (scrollTop < offsets[4] - header.offsetHeight) {
        setActiveSection(2);
      } else {
        setActiveSection(3);
      }
    }

  }, []);


  return (
    <main className="body-font">
      <NavBar activeSection={activeSection} />
      <About />
      <Projects />
      <Publications />
      <Teaching />
      <Contact />
    </main>
  );
}

export default App;
